import { createAsyncThunk } from "@reduxjs/toolkit";
import { gatewayInstance } from "../../axiosInstance";
import { SERVICE_ENDPOINT } from "../../const";

export const loadNotifications = createAsyncThunk(
  "loadNotifications",
  async (user) => {
    try {
      console.log(user);
      const data1 = {
        username: user,
        type: "",
        param: "",
      };
      const response = await gatewayInstance.post(
        `${SERVICE_ENDPOINT.TRANSPORT}/notification/all`,
        data1,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching notification data:", error);
    }
  },
);
